import { resendSignUpCode } from 'aws-amplify/auth';
import { mapCognitoErrorToGerman } from './authErrorMessages';

/**
 * Resends the verification code for user registration
 * @param {string} username - The username (email or phone number) to resend code to
 * @returns {Promise<{success: boolean, message: string}>} - Result of the operation
*/

export const resendVerificationCode = async (username) => {
  try {
    await resendSignUpCode({ username });
    return {
      success: true,
      message: 'Bestätigungscode wurde erneut gesendet.'
    };
  } catch (error) {
    return {
      success: false,
      message: mapCognitoErrorToGerman(error, 'Bestätigungscode konnte nicht erneut gesendet werden.')
    };
  }
};
